import React, { useEffect, useState } from "react";
import ContactInfo from "./Header/ContactInfo";
import LanguageCurrencyDropdown from "./Header/LanguageCurrencyDropdown";
import Logo from "./Header/Logo";
import MainMenu from "./Header/MainMenu";
import ReservationButton from "./Header/ReservationButton";
import SearchForm from "./Header/Search/SearchForm";
import dynamic from "next/dynamic";
import SocialMediaLinks from "./Header/SocialMediaLinks";

const FavoritesButton = dynamic(() => import("./Header/FavoritesButton"), {
  ssr: false,
});
const Header = ({ dataHeader, RoutingController }) => {
  const [isSticky, setIsSticky] = useState(false);
  const [language, setLanguage] = useState("tr");

  const handleLanguageChange = ({ language }) => {
    setLanguage(language);
  };
  
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setIsSticky((RoutingController === "Detail" || RoutingController === "Reservation") ? false : true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [RoutingController]);

  return (
    <header
      className={` lg:z-30 
        ${
          isSticky
            ? "lg:fixed top-0 left-0 w-full bg-white shadow-md headerFixed z-20"
            : "relative"
        }
          `}
    >
      <div className="bg-white lg:bg-headerbgColor border-b">
        <div className="container">
          <div className="flex items-center justify-between py-2 lg:py-0">
            <div className="flex items-center gap-9">
              <div className="lg:hidden">
                <Logo home={dataHeader?.Home} />
              </div>
              <div className="hidden lg:block">
                <SocialMediaLinks dataHeader={dataHeader} />
              </div>
              <div className="relative hidden lg:block">
                <SearchForm />
              </div>
            </div>
            <div className="flex items-center gap-2 sm:gap-5">
              <FavoritesButton />
              <LanguageCurrencyDropdown
                language={language}
                onLanguageChange={handleLanguageChange}
              />
              <div className="lg:hidden">
                <MainMenu dataHeader={dataHeader} />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="hidden lg:block lg:border-b border-[#ECEFF5] py-2">
        <div className="container">
          <div className="flex items-center justify-between ">
            <div className="flex items-center justify-between w-full gap-8 lg:justify-start lg:w-auto">
              <Logo home={dataHeader?.Home} />
              <div className="flex items-center">
                <div className="block lg:hidden">
                  <ReservationButton dataHeader={dataHeader} />
                </div>
                <MainMenu dataHeader={dataHeader} />
              </div>
            </div>
            <div className="items-center hidden lg:gap-8 lg:flex">
              <div className="hidden lg:block">
                <ContactInfo
                  dataFooter={dataHeader?.static}
                  image="/icons/customer.svg"
                  styles="text-themeBlack "
                />
              </div>
              <div className="hidden lg:block">
                <ReservationButton dataHeader={dataHeader} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
